import React from 'react'
import { Image } from 'Components/view-image'
import imageStyles from 'Components/view-image/style'
interface ISlide {
  className?: string
  items: IItem[]
  onClick?: (
    pic_size: 'small' | 'big',
    target_url: string,
    item_rank: 0 | 1 | undefined
  ) => void
}

interface IItem {
  type: 1101 | 1102 | 1103
  gid: string
  img_url: string
  title: string
  is_ugc: boolean
}

const Slide = (props: ISlide) => {
  const { className, items = [], onClick } = props

  if (items.length === 0) {
    return (
      <div
        className={`${className} g-load-img-wrap
      tw-h-0
      tw-pb-banner-sm 
      2xl:tw-pb-banner-2xl
      
    `}
      />
    )
  }
  const item1 = items.find((e) => e.type === 1101)
  const item2 = items.find((e) => e.type === 1102)
  const item3 = items.find((e) => e.type === 1103)
  return (
    <div
      className={`${className} slide
      tw-relative
      tw-bg-cover tw-bg-no-repeat 
      tw-bg-center
      tw-grid tw-grid-cols-24
      tw-gap-12
    `}
    >
      <div className="tw-col-span-24 2xl:tw-col-span-16 tw-overflow-hidden">
        <div className="tw-relative tw-pb-banner-big tw-h-0">
          <a
            href={`${item1?.is_ugc ? '/ugc' : ''}/article/${item1?.gid}`}
            target="_blank"
            rel="noopener noreferrer"
            className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-overflow-hidden"
            onClick={() => onClick?.('big', item1?.img_url || '', undefined)}
          >
            <Image
              hoverTransition
              src={item1?.img_url || ''}
              className="tw-object-cover tw-object-center tw-w-full tw-h-full"
              alt={item1?.title}
              width={677}
              height={268}
            />
          </a>
        </div>
      </div>

      <div className="tw-hidden tw-col-span-8 tw-flex-col 2xl:tw-flex  tw-min-w-0 tw-items-stretch tw-overflow-hidden tw-justify-between tw--ml-1">
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          href={`${item2?.is_ugc ? '/ugc' : ''}/article/${item2?.gid}`}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-overflow-hidden tw-h-0 tw-flex-shrink-0 tw-flex-grow-0 tw-mb-9 tw-relative tw-pt-banner-small upper tw-opacity-0"
          onClick={() => onClick?.('small', item2?.img_url || '', 0)}
        >
          <Image
            hoverTransition
            src={item2?.img_url || ''}
            className="tw-object-cover tw-object-center tw-w-full tw-h-full tw-absolute tw-left-0 tw-top-0"
            alt={item2?.title}
            width={391}
            height={123}
          />
        </a>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          href={`${item3?.is_ugc ? '/ugc' : ''}/article/${item3?.gid}`}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-overflow-hidden tw-h-0 tw-flex-shrink-0 tw-flex-grow-0 tw-relative tw-pt-banner-small lower tw-opacity-0"
          onClick={() => onClick?.('small', item3?.img_url || '', 1)}
        >
          <Image
            hoverTransition
            src={item3?.img_url || ''}
            className="tw-object-cover tw-object-center tw-w-full tw-h-full tw-absolute tw-left-0 tw-top-0"
            alt={item3?.title}
            width={391}
            height={123}
          />
        </a>
      </div>

      <style jsx>
        {`
          .upper {
            transition: opacity ease 0.2s 0.2s;
          }
          .lower {
            transition: opacity ease 0.2s 0.4s;
          }

          :global(.swiper-slide-active .upper, .swiper-slide-active .lower) {
            opacity: 1;
          }

          :global(.slide .motor-pc-image-hover:hover) {
            transform: scale(1.06);
          }
        `}
      </style>
      <style jsx global>
        {imageStyles}
      </style>
    </div>
  )
}

export default Slide
